import { Link } from 'react-router-dom';
import { FirmStatusBadge } from '../components/StatusBadge';
import { partnerGateway } from '../services';
import { useLoad } from '../state/useLoad';
import { usePartner } from '../state/usePartner';
import type { PartnerStatus } from '../types';

const MESSAGE: Record<Exclude<PartnerStatus, 'Active'>, string> = {
  ApplicationDraft: 'Your application has not been submitted. The application form is not in the portal yet, so it cannot be completed here. Contact Escochex to finish it.',
  Submitted: 'Your application has been submitted and is waiting for Escochex to review it.',
  UnderReview: 'Escochex is reviewing your application. You will be able to start once it is approved and a Partner Owner accepts the agreement.',
  InformationRequired: 'Escochex needs more information before it can continue.',
  Approved: 'Your application is approved. A Partner Owner must accept the agreement before your firm can start.',
  Suspended: 'Your firm is suspended, so you cannot work on clients right now.',
  Terminated: 'Your firm\'s partnership has ended. Its records and history are kept.',
  Rejected: 'Your application was not approved.',
};

/** What a firm that cannot operate yet (or any more) sees instead of the working portal. Only the firm's own profile, team list, security and agreement stay reachable. */
export function FirmStatusPage() {
  const { membership, can } = usePartner();
  const org = useLoad((signal) => partnerGateway.getOrganization(membership.partnerOrganizationId, signal), membership.partnerOrganizationId, 'The firm status could not be loaded.');
  const status = membership.status;

  return (
    <>
      <h1>{membership.legalName}</h1>
      <section className="pp-card" aria-labelledby="pp-status-h">
        <h2 id="pp-status-h">Firm status: <FirmStatusBadge status={status} /></h2>
        {status !== 'Active' && <p>{MESSAGE[status]}</p>}
        {org.data?.statusReason && <p><strong>From Escochex:</strong> {org.data.statusReason}</p>}
        {org.error && <p role="alert" className="pp-error">{org.error}</p>}
        {status === 'Approved' && can('partner.agreement.accept') && <Link className="pp-button pp-button--primary" to="/partner/settings/agreements">Review and accept the agreement</Link>}
      </section>
    </>
  );
}
